"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.typeKeys = exports.enchancedEcommerceOrWishlistFieldKeys = exports.googleFieldKeys = void 0;

var _typeTransformers = require("./helpers/typeTransformers");

// eslint-disable-next-line import/prefer-default-export
var googleFieldKeys = {
  stock: 'dimension51',
  colour: 'dimension22',
  size: 'dimension23',
  addToCart: 'dimension60',
  isMarkedDown: 'dimension50',
  discounts: ['coupon', function (value) {
    if (value && value.length > 0) {
      return value.join(',');
    }

    return '';
  }],
  discountsAmount: 'couponDiscount',
  division: 'dimension30',
  deliveryProvider: 'dimension87',
  deliveryType: 'dimension88'
};
exports.googleFieldKeys = googleFieldKeys;
var enchancedEcommerceOrWishlistFieldKeys = {
  subcategory: 'dimension61',
  subCategory: 'dimension61'
};
exports.enchancedEcommerceOrWishlistFieldKeys = enchancedEcommerceOrWishlistFieldKeys;
var typeKeys = {
  'product-landing': {
    keyName: 'productView',
    formatFunc: _typeTransformers.formatProductView
  },
  purchase: {
    keyName: 'purchase',
    formatFunc: _typeTransformers.formatPurchase
  },
  checkout: {
    keyName: 'checkout',
    formatFunc: _typeTransformers.formatCheckout
  },
  'checkout-globale': {
    keyName: 'checkout',
    formatFunc: _typeTransformers.formatCheckout
  },
  productClick: {
    keyName: 'productClick',
    formatFunc: _typeTransformers.formatProductClick
  },
  wishlistInteraction: {
    keyName: 'wishlistInteraction',
    formatFunc: _typeTransformers.formatwishlistInteraction
  }
};
exports.typeKeys = typeKeys;